import apiFarms from "../config/api_farms";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// Mock data from lovable-material-hub/data/estoqueMock.ts
// const MOCK_ITENS_ESTOQUE = [
//   {
//     id: "ie1",
//     internalId: "MAT-001",
//     abbreviation: "VACINA-AFT",
//     description: "Vacina Aftosa",
//     itemGroup: "sg9",
//     measurementUnit: "um6",
//     currentQty: 200,
//     replenishmentPoint: 50,
//     currentCost: 3.5,
//     lastPurchaseCost: 3.75,
//     lastPurchaseDate: "2025-01-15",
//     lastSupplier: "f3",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: true,
//     variants: [
//       {
//         id: "p1",
//         internalId: "P001-A",
//         batchNumber: "LT2024-01",
//         currentQty: 120,
//         expirationDate: "2025-06-15",
//       },
//       {
//         id: "p2",
//         internalId: "P001-B",
//         batchNumber: "LT2024-03",
//         currentQty: 80,
//         expirationDate: "2025-09-20",
//       },
//     ],
//   },
//   {
//     id: "ie2",
//     internalId: "MAT-002",
//     abbreviation: "SAL-MIN",
//     description: "Sal Mineral Proteinado",
//     itemGroup: "sg7",
//     measurementUnit: "um2",
//     currentQty: 2500,
//     replenishmentPoint: 500,
//     currentCost: 2.1,
//     lastPurchaseCost: 2.1,
//     lastPurchaseDate: "2025-02-10",
//     lastSupplier: "f2",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: true,
//     variants: [
//       {
//         id: "p3",
//         internalId: "P002-A",
//         batchNumber: "LT2024-05",
//         currentQty: 2500,
//         expirationDate: "2026-01-10",
//       },
//     ],
//   },
//   {
//     id: "ie3",
//     internalId: "MAT-003",
//     abbreviation: "IVERMEC",
//     description: "Ivermectina 1%",
//     itemGroup: "sg10",
//     measurementUnit: "um4",
//     currentQty: 350,
//     replenishmentPoint: 100,
//     currentCost: 0.85,
//     lastPurchaseCost: 0.9,
//     lastPurchaseDate: "2024-11-20",
//     lastSupplier: "f3",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: true,
//     variants: [
//       {
//         id: "p4",
//         internalId: "P003-A",
//         batchNumber: "LT2024-08",
//         currentQty: 350,
//         expirationDate: "2025-12-01",
//       },
//     ],
//   },
//   {
//     id: "ie4",
//     internalId: "MAT-004",
//     abbreviation: "ARAME-F",
//     description: "Arame Farpado",
//     itemGroup: "sg20",
//     measurementUnit: "um5",
//     currentQty: 1500,
//     replenishmentPoint: 200,
//     currentCost: 1.2,
//     hasVariant: false,
//     batchControl: false,
//     active: true,
//     hasMovement: false,
//   },
//   {
//     id: "ie5",
//     internalId: "MAT-005",
//     abbreviation: "BRINCO-ID",
//     description: "Brinco de Identificação",
//     itemGroup: "sg16",
//     measurementUnit: "um1",
//     currentQty: 630,
//     replenishmentPoint: 100,
//     currentCost: 4.5,
//     lastPurchaseCost: 4.8,
//     lastPurchaseDate: "2025-01-28",
//     lastSupplier: "f4",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: true,
//     variants: [
//       {
//         id: "p5",
//         internalId: "P005-A",
//         batchNumber: "LT2024-12",
//         currentQty: 430,
//       },
//       {
//         id: "p6",
//         internalId: "P005-B",
//         batchNumber: "LT2025-01",
//         currentQty: 200,
//       },
//     ],
//   },
//   {
//     id: "ie6",
//     internalId: "MAT-006",
//     abbreviation: "RAÇÃO-ENG",
//     description: "Ração de Engorda",
//     itemGroup: "sg6",
//     measurementUnit: "um2",
//     currentQty: 5000,
//     replenishmentPoint: 1000,
//     currentCost: 1.8,
//     lastPurchaseCost: 1.8,
//     lastPurchaseDate: "2025-02-20",
//     lastSupplier: "f2",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: true,
//     variants: [
//       {
//         id: "p7",
//         internalId: "P006-A",
//         batchNumber: "LT2025-02",
//         currentQty: 5000,
//         expirationDate: "2025-08-30",
//       },
//     ],
//   },
//   {
//     id: "ie7",
//     internalId: "MAT-007",
//     abbreviation: "DIESEL-S10",
//     description: "Diesel S10",
//     itemGroup: "sg3",
//     measurementUnit: "um3",
//     currentQty: 3200,
//     replenishmentPoint: 500,
//     currentCost: 5.89,
//     hasVariant: false,
//     batchControl: false,
//     active: true,
//     hasMovement: false,
//   },
//   {
//     id: "ie8",
//     internalId: "MAT-008",
//     abbreviation: "SEMENT-BRA",
//     description: "Semente de Brachiária",
//     itemGroup: "sg36",
//     measurementUnit: "um2",
//     currentQty: 800,
//     replenishmentPoint: 200,
//     currentCost: 12.5,
//     lastPurchaseCost: 12.5,
//     lastPurchaseDate: "2025-03-01",
//     lastSupplier: "f5",
//     hasVariant: true,
//     batchControl: false,
//     active: true,
//     hasMovement: false,
//     variants: [
//       {
//         id: "p8",
//         internalId: "P008-A",
//         batchNumber: "LT2025-03",
//         currentQty: 500,
//         expirationDate: "2026-06-01",
//       },
//       {
//         id: "p9",
//         internalId: "P008-B",
//         batchNumber: "LT2025-04",
//         currentQty: 300,
//       },
//     ],
//   },
// ];

export function callStockItemIndex(payload) {
  // const { page = 1, size = 10 } = payload;
  // const start = page * size;
  // const results = MOCK_ITENS_ESTOQUE.slice(start, start + size);
  // console.log("callStockItemIndex called with payload:", payload);
  // console.log("Returning mock data:", results);
  // return Promise.resolve({
  //   data: { results, total: MOCK_ITENS_ESTOQUE.length },
  // });

  const { groupId, farmId, signal, unlinkedItemsOnly = false } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/items${
      unlinkedItemsOnly ? "?unlinkedItemsOnly=true" : ""
    }`,
    getHeaders(false, signal),
  );
}

export function callStockItemSearchByInternalId(payload) {
  const { groupId, farmId, signal, search } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/search/internal-id${
      search ? `?search=${search}` : ""
    }`,
    getHeaders(false, signal),
  );
}

export function callStockItemShow(payload) {
  // const { id } = payload;
  // const found = MOCK_ITENS_ESTOQUE.find((item) => item.id === id) ?? null;
  // return Promise.resolve({ data: found });

  const { groupId, farmId, id, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}`,
    getHeaders(false, signal),
  );
}

export function callStockItemSave(payload) {
  const { groupId, farmId, id, item, signal } = payload;
  if (id) {
    return apiFarms.put(
      `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}`,
      item,
      getHeaders(false, signal),
    );
  }
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/stock/items`,
    item,
    getHeaders(false, signal),
  );
}

export function callStockItemDelete(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.delete(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}`,
    getHeaders(false, signal),
  );
}

export function callStockItemToggleStatus(payload) {
  const { groupId, farmId, id, active, signal } = payload;
  if (active) {
    return apiFarms.post(
      `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}/activate`,
      {},
      getHeaders(false, signal),
    );
  }
  return apiFarms.patch(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}/inactivate`,
    { active },
    getHeaders(false, signal),
  );
}

export function callStockItemVariants(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}/variants`,
    getHeaders(false, signal),
  );
}

export function callSaveStockItemVariant(payload) {
  const { groupId, farmId, itemId, variant, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${itemId}/variants`,
    variant,
    getHeaders(false, signal),
  );
}

export function callStockItemJournal(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${id}/stock-journal`,
    getHeaders(false, signal),
  );
}

export function callSaveStockItemBatch(payload) {
  const { groupId, farmId, itemId, batch, signal } = payload;
  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/stock/items/${itemId}/batches`,
    batch,
    getHeaders(false, signal),
  );
}
